import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=acdf3772&"
import script from "./AllNews.vue?vue&type=script&lang=js&"
export * from "./AllNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports